export default __webpack_public_path__ + "static/media/visa.525f133f.svg";